import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-chart-options',
	templateUrl:'./AgChartOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./AgChartOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChartOptionsPluginCompPage
{
	mdContent_702 = `\`\`\`java
import com.jwebmp.plugins.agcharts.options.AgChartOptions;
\`\`\``;
}
